import { useEffect, useState } from 'react'
import PriceInfoUI from './UI'
import { getDefaultForCountry } from '@merchant-portal/mp-models/lib/locale/languages'
import { getLanguageFromCountry } from '../../models/countries'
import { getPriceInfoForBankproduct } from '../../api/payment-methods-pricing-api'
import { translator } from '../../internal/Text'
import moment from 'moment'

const QueryParams = {
  COUNTRY_CODE: 'countryCode',
  BANKPRODUCT_ID: 'authorizedBankproductId',
  STORE_ID: 'storeId',
  REPRESENTATIVE_ID: 'representativeId',
  CREDIT_AMOUNT: 'creditAmount',
  REPAYMENT_PERIOD: 'repaymentPeriod',
  INTEREST_RATE: 'interestRate',
}

const addOptionalParams = params =>
  Object.entries(params)
    .filter(([key, val]) => val != null)
    .reduce((r, [key, val]) => ({ ...r, [key]: val }), {})

const DefaultChannelType = 'ECOMMERCE'

const PriceInfoBankproduct = () => {
  const [amount, setAmount] = useState(null)
  const [request, setRequest] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [priceInfo, setPriceInfo] = useState(null)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    setRequest({
      storeId: params.get(QueryParams.STORE_ID),
      representativeId: params.get(QueryParams.REPRESENTATIVE_ID),
      channelType: params.get(QueryParams.CHANNEL_TYPE) || DefaultChannelType,
      amount: params.get(QueryParams.CREDIT_AMOUNT),
      bankproduct: params.get(QueryParams.BANKPRODUCT_ID),
      countryCode: params.get(QueryParams.COUNTRY_CODE),
      ...addOptionalParams({
        repaymentPeriod: params.get(QueryParams.REPAYMENT_PERIOD),
        interestRate: params.get(QueryParams.INTEREST_RATE),
      }),
    })
    const country = params.get(QueryParams.COUNTRY_CODE)
    setLocale({
      country: country,
      language: getLanguageFromCountry(country),
    })
  }, [])

  useEffect(() => {
    if (
      !!request &&
      Object.values(request).length &&
      Object.values(request).every(
        value => value !== undefined && value !== null,
      )
    ) {
      setAmount(null)
      setIsLoading(true)
      getPriceInfoForBankproduct(request)
        .then(data => {
          setPriceInfo(data)
          setLocale({
            country: data.country,
            language:
              getLocale().language || getDefaultForCountry(data.country),
          })
        })
        .catch(() => setPriceInfo(null))
        .finally(() => setIsLoading(false))
    }
  }, [request])

  const getLocale = () => JSON.parse(localStorage.getItem('locale'))

  const setLocale = locale => {
    localStorage.setItem('locale', JSON.stringify(locale))
    translator.setLanguage(locale.language)
    moment.locale(locale.language)
  }

  const handleSubmitAmount = () => {
    setRequest({ ...request, amount })

    const params = new URLSearchParams(window.location.search)
    params.set(QueryParams.CREDIT_AMOUNT, amount)
    window.location.search = params
  }

  return (
    <PriceInfoUI
      amount={amount}
      priceInfo={priceInfo}
      isLoading={isLoading}
      onAmountChange={setAmount}
      onAmountSubmit={handleSubmitAmount}
    />
  )
}

export default PriceInfoBankproduct
